import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  Typography,
  FormControl,
  TextField,
  CardContent,
  Grid,
  Button,
  MenuItem,
  Select,
  CircularProgress,
  Paper,
  Box,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { CloudUploadRounded } from "@mui/icons-material";
import Key from "../../clientVariables.json";
import {
  addCandidateAction,
  alertSnackBarAction,
  getCandidateDetailAction,
  getActiveCandidatesAction,
  getCandidatesAction,
  getCandidateResumeListAction,
} from "../redux/action";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../redux/selector";
import { userSelector } from "../user-redux/selector";
import { parse } from "date-fns";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const FileUploader = ({
  check,
  candidatesRefreshHandler,
  closeResumeParserModal,
  popupsHandler,
}) => {
  const dispatch = useDispatch();
  const { selectedCandidate } = useSelector(appSelector);

  const { user } = useSelector(userSelector);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [parsedFileData, setParsedFileData] = useState([]);
  const [addCandidateData, setAddCandidateData] = useState([]);
  const [addResumesData, setAddResumesData] = useState([]);
  const [addCandidateAndAddResumeToS3, setAddCandidateAndAddResumeToS3] =
    useState([]);
  const [comonApiLoad, setComonApiLoad] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    jobTitle: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const {
    activeCandidates,
  } = useSelector(appSelector);

  const MAX_FILES = 5;

  const validateForm = () => {
    let errors = {};
    let isValid = true;

    if (!formData.name.trim()) {
      errors.name = "Name is required";
      isValid = false;
    }

    if (!formData.email.trim()) {
      errors.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Email is invalid";
      isValid = false;
    }

    if (!formData.jobTitle.trim()) {
      errors.jobTitle = "Job Title is required";
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  // useEffect(() => {
  //   if (Array.isArray(activeCandidates)) {
  //     activeCandidates.forEach((candidate) => {
  //       console.log("Candidate email:", candidate.email);
  //     });
  //   } else if (activeCandidates && activeCandidates.email) {
  //     console.log("Active candidate email:", activeCandidates.email);
  //   }
  // }, [activeCandidates]);

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      if (check === "add_candidates") {
        const singleFile = files[0]; // Only take the first file
        validateAndAddFile(singleFile);
        getParseData(singleFile);
      } else if (check === "add_resumes") {
        // Allow multiple file uploads for add_resumes
        Array.from(files).forEach((file) => {
          validateAndAddFile(file);
          getParseData(file);
        });
      }
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (check === "add_candidates") {
      // Only take the first file if adding candidates
      if (files.length > 0) {
        const singleFile = files[0];
        validateAndAddFile(singleFile);
        getParseData(singleFile);
      }
    } else if (check === "add_resumes") {
      // Allow multiple file drops for adding resumes
      Array.from(files).forEach((file) => {
        validateAndAddFile(file);
        getParseData(file);
      });
    }
  };

  const validateAndAddFile = (file) => {
    const allowedFileTypes = [".docx", ".doc", ".pdf"];

    if (selectedFiles.length >= MAX_FILES) {
      popupsHandler(`You can upload a maximum of ${MAX_FILES} files.`, "error");
    } else if (
      !allowedFileTypes.includes(file.name.slice(file.name.lastIndexOf(".")))
    ) {
      popupsHandler(
        `You can add only .docx, .doc and .pdf files. The following file was not added: ${file.name}`,
        "error"
      );
    } else {
      setSelectedFiles([...selectedFiles, file]);
    }
  };

  const handleRemove = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);
    setFormOpen(false);
    setFormData({
      name: "",
      email: "",
      jobTitle: "",
    });
  };

  function validateEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(email)) {
      return false;
    }

    const invalidDomains = ["example.com", "test.com", "email.com"];

    const domain = email.split("@")[1];

    if (invalidDomains.includes(domain)) {
      return false;
    }

    return true;
  }

  const normalize = (str) => {
    if (Array.isArray(str)) str = str[0] || "";
    return typeof str === "string" ? str.toLowerCase().trim().replace(/\s+/g, "") : "";
  };

  const handleUpload = async () => {
    let normalizedFormData = { ...formData };
    const trimedEmail = normalize(normalizedFormData.email);
    normalizedFormData.name = normalizedFormData.name.trim();
    normalizedFormData.jobTitle = normalizedFormData.jobTitle.trim();
    try {
      if (selectedFiles.length > 0) {
        if (check === "add_candidates") {
          if (validateForm()) {
            setIsUploading(true);

            // Check if email exists in activeCandidates
            const emailExists = Array.isArray(activeCandidates)
              ? activeCandidates.some(candidate => candidate.email === trimedEmail)
              : activeCandidates?.email === trimedEmail;

            if (emailExists) {
              popupsHandler("A candidate with this email already exists", "error");
              setIsUploading(false);
              return;
            }

            // Rest of your existing add_candidates logic...
            for (const element of addCandidateData) {
              element.candidateData.firstname = normalizedFormData.firstName;
              element.candidateData.lastname = normalizedFormData.lastName;
              element.candidateData.email = trimedEmail;
              element.candidateData.jobtitle = normalizedFormData.jobTitle;

              const parsedEmail = element?.candidateData?.email || null;
              const validEmail = await validateEmail(parsedEmail);

              if (validEmail) {
                const responseData = await dispatch(
                  addCandidateAction(
                    element?.candidateData,
                    user?.id,
                    element?.fileData
                  )
                );

                if (responseData.data === "Candidate already exist") {
                  await dispatch(getActiveCandidatesAction(user?.id, 1, 20));
                  popupsHandler(responseData.data, "error");
                }
                const resume = addCandidateAndAddResumeToS3.find(
                  (item) => item.fileData === element.fileData
                );
                const resumeData = resume?.parsedData;
                const file = resume?.fileData;

                if (responseData?.data?.insertId) {
                  handleUpdateCandidateDetails(responseData?.data.insertId);
                  const solrSearchArray = (resumeData?.solr_searchstring || "")
                    .replace("job_role:(", "")
                    .replace(/\\"/g, '"')
                    .replace(")", "")
                    .split(" OR ");
                  const resumePayload = {
                    candidate_id: responseData?.data.insertId,
                    ai_skills: resumeData?.skills?.join(","),
                    user_id: selectedCandidate?.user_id,
                    application_title: resumeData?.job_title,
                    full_name: resumeData?.name,
                    first_name: resumeData?.first_name,
                    last_name: resumeData?.last_name,
                    home_phone: resumeData?.phone,
                    email_address: resumeData?.email,
                    total_experience: resumeData?.experience_in_years,
                    location_state: resumeData?.location_state || "",
                    location_city: resumeData?.location_city || "",
                    address_zipcode: "",
                    skills_ids: "",
                    summary: resumeData?.summary || "",
                    current_role: resumeData?.job_title,
                    status: "1",
                    skills_titles: resumeData?.related_skills?.join(",") || "",
                    location_country: "",
                    jobtype: "",
                    uploaded_uid: user?.id,
                    visatype: resumeData?.visa || "",
                    full_address:
                      resumeData?.location !== ", "
                        ? resumeData?.location
                        : "" || "",
                    resume_string: resumeData?.resume_string || "",
                    willingToRelocate: "",
                    solr_search_string:
                      solrSearchArray !== "" && solrSearchArray !== null
                        ? solrSearchArray?.join(",")
                        : "",
                    source: "fromBenchsales",
                    primary: "",
                    linkedin_url:
                      resumeData?.linkedin_url !== ""
                        ? resumeData?.linkedin_url
                        : "",
                    filename: resumeData?.filename,
                    projects_data:
                      resumeData?.projects?.length > 0
                        ? resumeData?.projects
                        : [],
                    educations_data:
                      resumeData?.educations?.length > 0
                        ? resumeData?.educations
                        : [],
                    certificates_data:
                      resumeData?.certifications?.length > 0
                        ? resumeData?.certifications
                        : [],
                  };
                  const response = await axios.post(
                    `${Key.domain}/candidate/bench_addFullResume`,
                    resumePayload
                  );
                  const resumeId = response?.data?.data?.insertId;
                  const data = new FormData();
                  data.append("file", file);
                  data.append("userid", selectedCandidate?.user_id);
                  data.append("candidateid", responseData?.data.insertId);
                  data.append("filename", file?.name);
                  data.append("file_size", file?.size);
                  data.append("file_type", file?.type);
                  data.append("attachment_type", "Candidate_res_attachment");
                  data.append("attachment_name", file?.name);
                  data.append("file_created", file?.lastModifiedDate);
                  data.append("resumeid", resumeId);
                  data.append("role", resumeData?.job_title);
                  await axios.post(
                    `${Key.domain}/candidate/upload_document`,
                    data
                  );
                  await candidatesRefreshHandler(true);
                  popupsHandler("Candidate added successfully", "success");
                }
                setIsUploading(false);
                closeResumeParserModal(true);
              } else {
                popupsHandler(`Invalid email: ${parsedEmail}`, "error");
              }
            }
          }
        } else if (check === "add_resumes") {
          setIsUploading(true);

          // For add_resumes, we need to check if the parsed email matches the selected candidate's email
          for (let i = 0; i < addResumesData.length; i++) {
            const resumeData = addResumesData[i];
            const normalize = (str) => {
              if (Array.isArray(str)) str = str[0] || "";
              return typeof str === "string" ? str.toLowerCase().trim().replace(/\s+/g, "") : "";
            }; // remove all extra spaces

            const parsedEmail = normalize(normalizedFormData.email);
            const parsedName = normalize(normalizedFormData.name);

            const selectedCandidateEmail = normalize(selectedCandidate?.email);
            const selectedCandidateName = normalize(selectedCandidate?.candidate_name);

            if (!parsedEmail || parsedEmail === "") {
              popupsHandler("Cannot add resume: Email not available in resume", "error");
              continue;
            }
            // if (parsedEmail !== selectedCandidateEmail && parsedName !== selectedCandidateName) {
            //   popupsHandler(`Cannot add resume: Name ${parsedName} doesn't match candidate's name ${selectedCandidateName} AND email ${parsedEmail} doesn't match candidate's email ${selectedCandidateEmail}`, "error");
            //   continue;
            // } else if (parsedName !== selectedCandidateName) {
            //   popupsHandler(`Cannot add resume: Name ${parsedName} doesn't match candidate's name ${selectedCandidateName}`, "error");
            //   continue;
            // } else if (parsedEmail !== selectedCandidateEmail) {
            //   popupsHandler(`Cannot add resume: Email ${parsedEmail} doesn't match candidate's email ${selectedCandidateEmail}`, "error");
            //   continue;
            // }
            // Only require email to match (removed name matching requirement)
            if (parsedEmail !== selectedCandidateEmail) {
              popupsHandler(`Cannot add resume: Email ${parsedEmail} doesn't match candidate's email ${selectedCandidateEmail}`, "error");
              continue;
            }

            // If emails match or no email in resume, proceed with upload
            // Rest of your existing add_resumes logic...
            const solrSearchArray = (resumeData?.solr_search_string || "")
              .replace("job_role:(", "")
              .replace(/\\"/g, '"')
              .replace(")", "")
              .split(" OR ");
            const file = addCandidateAndAddResumeToS3[i].fileData;
            const response = await axios.post(
              `${Key.domain}/candidate/bench_addFullResume`,
              {
                candidate_id: selectedCandidate?.candidate_id,
                ai_skills: resumeData?.ai_skills,
                user_id: selectedCandidate?.user_id,
                application_title: resumeData?.application_title,
                full_name: normalizedFormData?.name,
                // first_name: resumeData?.first_name,
                // last_name: resumeData?.last_name,
                home_phone: resumeData?.home_phone,
                email_address: normalizedFormData?.email,
                total_experience: resumeData?.total_experience,
                location_state: resumeData?.location_state || "",
                location_city: resumeData?.location_city || "",
                address_zipcode: "",
                skills_ids: "",
                summary: resumeData?.summary || "",
                current_role: resumeData?.current_role,
                status: "1",
                skills_titles: resumeData?.skills_titles || "",
                location_country: "",
                jobtype: "",
                uploaded_uid: user?.id,
                visatype: resumeData?.visatype || "",
                full_address:
                  resumeData?.full_address !== ", "
                    ? resumeData?.full_address
                    : "" || "",
                resume_string: resumeData?.resume_string || "",
                willingToRelocate: "",
                solr_search_string:
                  solrSearchArray !== "" && solrSearchArray !== null
                    ? solrSearchArray
                    : "",
                source: "fromBenchsales",
                primary: "",
                linkedin_url:
                  resumeData?.linkedin_url !== ""
                    ? resumeData?.linkedin_url
                    : "",
                filename: resumeData?.filename,
                projects_data:
                  resumeData?.projects?.length > 0
                    ? resumeData?.projects
                    : [],
                educations_data:
                  resumeData?.educations_data?.length > 0
                    ? resumeData?.educations_data
                    : [],
                certificates_data:
                  resumeData?.certificates_data?.length > 0
                    ? resumeData?.certificates_data
                    : [],
              }
            );
            const resumeId = response?.data?.data?.insertId;
            const data = new FormData();
            data.append("file", file);
            //data.append("file", file);
            data.append("userid", selectedCandidate?.user_id);
            data.append(
              "candidateid",
              selectedCandidate?.candidate_id
                ? selectedCandidate.candidate_id
                : selectedCandidate?.candidate_id
            );
            data.append("filename", file?.name);
            data.append("file_size", file?.size);
            data.append("file_type", file?.type);
            data.append("attachment_type", "Candidate_res_attachment");
            data.append("attachment_name", file?.name);
            data.append("file_created", file?.lastModifiedDate);
            data.append("resumeid", resumeId);
            data.append("role", resumeData?.application_title);

            await axios.post(`${Key.domain}/candidate/upload_document`, data);

            popupsHandler("Resume added successfully", "success");
            const candidateData = {
              candidate_id: selectedCandidate?.candidate_id,
              user_id: user?.id,
            };
            dispatch(getCandidateResumeListAction(candidateData));
          }
        }
        setIsUploading(false);
        closeResumeParserModal(true);
      }
      else {
        popupsHandler("No files selected", "warning");
      }
    } catch (error) {
      console.error("Error uploading files:", error);
      popupsHandler("Failed to upload files", "error");
      setIsUploading(false);
      closeResumeParserModal(true);
    }
  };

  const getParseData = async (fileData) => {
    setComonApiLoad(true);
    try {
      const formData = new FormData();
      formData.append("resume", fileData);

      const response = await fetch(Key.resume_parser_ai_4, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Failed to parse data: ${response.statusText}`);
      }

      const body = await response.json();

      const email = Array.isArray(body.data?.email) ? body.data.email[0] : body.data?.email || "";
      const phone = Array.isArray(body.data?.phone) ? body.data.phone[0] : body.data?.phone || "";


      if (
        body.statusCode === 200 &&
        body.data !== undefined &&
        body.data !== null
      ) {
        if (check === "add_candidates") {
          const candidateData = await {
            userid: user?.id,
            firstname: body.data?.first_name,
            middlename: "",
            lastname: body.data?.last_name,
            email: email,
            phone: phone,
            date_of_birth: "",
            candidate_status: "Active",
            jobtitle: body.data?.job_title,
            visatype: body.data?.visa,
            related_titles: "",
            experience: body.data?.experience_in_years,
            address: "",
            zipcode: "",
            countryid: "",
            stateid: "",
            cityid: "",
            skills: body.data?.skills,
            summary: body.data?.summary,
            linkedInUrl: body.data?.linkedin_url,
            jobtypeid: "",
            availabledate: "",
            ratefrom: "",
            rateto: "",
            currentratetype: "",
            currentrate: "",
            gender: "",
            willingToRelocate: "No",
            role: body.data?.job_title,
          };
          setAddCandidateData((prev) => [
            ...prev,
            { fileData, parsedData: body.data, candidateData },
          ]);
          setAddCandidateAndAddResumeToS3((prev) => [
            ...prev,
            { parsedData: body.data, fileData },
          ]);
          setFormData({
            name: body.data.name || "",
            email: body.data.email || "",
            jobTitle: body.data.job_title || "",
          });
          setFormOpen(true);
          popupsHandler("Resume parsed successfully", "success");
        } else if (check === "add_resumes") {
          const inputString = (await body.data?.solr_searchstring) || "";
          const solrSearchArray = await inputString
            .replace("job_role:(", "")
            .replace(/\\"/g, '"')
            .replace(")", "")
            .split(" OR ");
          const resumeData = await {
            candidate_id: selectedCandidate?.candidate_id,
            ai_skills: body.data?.skills?.join(",") || "",
            user_id: user?.id,
            application_title: body.data?.job_title || "",
            full_name: body.data?.name || "",
            first_name: body.data?.first_name || "",
            last_name: body.data?.last_name || "",
            home_phone: phone,
            email_address: email,
            total_experience: body.data?.experience_in_years,
            location_state: body.data?.location_state || "",
            location_city: body.data?.location_city || "",
            address_zipcode: "",
            skills_ids: "",
            summary: body.data?.summary || "",
            current_role: body.data?.job_title,
            status: "1",
            skills_titles: body.data?.related_skills?.join(",") || "",
            location_country: "",
            jobtype: "",
            visatype: body.data?.visa || "",
            full_address: body.data?.location || "",
            resume_string: body.data?.resume_string || "",
            willingToRelocate: "",
            solr_search_string: body.data?.solr_searchstring,
            source: "fromBenchsales",
            primary: "",
            linkedin_url: body.data?.linkedin_url || "",
            filename: body.data?.filename,
            projects: body.data?.projects || [],
            educations_data: body.data?.educations || [],
            certificates_data: body.data?.certifications || [],
          };
          setFormData({
            name: body.data.name || "",
            email: body.data.email || "",
            jobTitle: body.data.job_title || "",
          });
          setFormOpen(true);
          setAddResumesData((prev) => [...prev, resumeData]);
          //console.log("Parsed resume data:", resumeData);
          setAddCandidateAndAddResumeToS3((prev) => [
            ...prev,
            { parsedData: body.data, fileData },
          ]);
          popupsHandler("Resume parsed successfully", "success");
        }
      } else {
        throw new Error("Failed to parse data: invalid response format");
      }
    } catch (err) {
      console.error("Error parsing resume:", err);
      popupsHandler("Failed to parse resume, please try again", "error");
    } finally {
      setComonApiLoad(false);
    }
  };

  const handleInputChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const handleUpdateCandidateDetails = async (candidateId) => {
    try {
      const response = await axios.post(
        `${Key.domain}/candidate/update/personal/${candidateId}`,
        {
          userid: user?.id,
          name: formData.name?.trim(),
          email: formData.email?.toLowerCase().trim(),
          jobtitle: formData.jobTitle?.trim(),
        }
      );
      // dispatch(getCandidateDetailAction(selectedCandidate?.candidate_id));
      popupsHandler("candidate personal details updated", "success");
    } catch (error) {
      console.error(error);
      popupsHandler("something went wrong", "error");
    }
  };

  return (
    <>
      <Paper
        sx={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
      >
        <Typography variant="h6" gutterBottom>
          Upload Resume Files To Add{" "}
          {check === "add_candidates" ? "Candidates" : "Resumes"}
          {/* `Resumes For ${selectedCandidate?.candidate_name}` */}
        </Typography>
        <input
          accept=".docx, .pdf, .doc"
          id="file-upload"
          type="file"
          style={{ display: "none" }}
          onChange={handleFileChange}
          multiple
        />
        <label htmlFor="file-upload">
          <Button variant="outlined" component="span">
            {check === "add_candidates" ? "Select File" : "Select Files"}
          </Button>
        </label>
        <CloudUploadRounded
          sx={{ color: "#406882", height: "80px", width: "80px" }}
        />
        <Typography variant="subtitle1" style={{ marginTop: "2px" }}>
          or drag and drop files here
        </Typography>
        {formOpen ? (
          <Grid
            container
            spacing={2}
            sx={{
              ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
                padding: "8px 6px",
              },
              ".css-nxo287-MuiInputBase-input-MuiOutlinedInput-input": {
                padding: "8px 6px",
              },
              ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
                { padding: "8px 6px" },
            }}
          >
            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Name
                </Typography>
                <TextField
                  id="name"
                  label=""
                  variant="outlined"
                  placeholder="name"
                  value={formData.name}
                  error={!!formErrors.name}
                  onChange={handleInputChange("name")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Email
                </Typography>
                <TextField
                  id="email"
                  label=""
                  variant="outlined"
                  placeholder="example@gmail.com"
                  value={formData.email}
                  error={!!formErrors.email}
                  onChange={handleInputChange("email")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Job Title
                </Typography>
                <TextField
                  id="jobTitle"
                  label=""
                  variant="outlined"
                  placeholder="Eg: Web Developer"
                  value={formData.jobTitle}
                  error={!!formErrors.jobTitle}
                  onChange={handleInputChange("jobTitle")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>
          </Grid>
        ) : null}
        {selectedFiles.map((file, index) => (
          <div key={index} style={{ marginTop: "10px", display: "flex" }}>
            <Typography
              sx={{
                minWidth: "150px",
                maxWidth: "150px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {file.name}
            </Typography>
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              style={{ marginLeft: "10px" }}
              onClick={() => handleRemove(index)}
            >
              {comonApiLoad ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Remove"
              )}
            </Button>
          </div>
        ))}
        <Button
          variant="contained"
          fullWidth
          color="primary"
          style={{
            marginTop: "20px",
            backgroundImage:
              "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)",
            textTransform: "capitalize",
          }}
          disabled={comonApiLoad}
          onClick={handleUpload}
        >
          {isUploading ? (
            <CircularProgress size={20} color="inherit" />
          ) : check === "add_candidates" ? (
            "Add Candidate"
          ) : (
            "Add Resumes"
          )}
        </Button>
      </Paper>
    </>
  );
};

export default FileUploader;

const labelStyles = {
  color: "rgb(160, 171, 184)",
  marginBottom: "5px",
};

const inputStyles = {
  border: "1px solid 	rgb(224, 230, 247)",
  borderRadius: "4px",
  "&:hover": {
    border: "1px solid 	rgb(224, 230, 247)",
    borderRadius: "4px",
  },
};
